import React, { FC, useState } from 'react'
import { useMutation } from '@apollo/client'
import { useHistory } from 'react-router-dom'
import { BookingCreateUserMutation, CreateBookingUserRequest } from 'parkdepot-shared/gql/graphql'

import { Container } from './Register.style'
import RegisterForm from '../../components/RegisterForm/RegisterForm.component'
import { CREATE_USER } from '../../graphql/mutation/createUser.mutation'
import { useLogin } from '../../hooks/useAuth'
import { NotificationType } from '../../types/notification.enum'
import RegisterNotifications from '../../components/RegisterForm/RegisterNotifications'
import { SeoHead } from '@components/SeoHead/SeoHead.component'
import { getLanguageBasedOnDomain } from '@utils/getDomainExtension'
import { useTranslation } from 'react-i18next'

const Register: FC = () => {
    const [loading, setLoading] = useState(false)
    const [showNotification, setShowNotification] = useState<NotificationType | null>(null)
    const login = useLogin()
    const history = useHistory()
    const { i18n } = useTranslation()
    const seoLang = i18n.getFixedT(getLanguageBasedOnDomain())

    const [createUser] = useMutation<
        BookingCreateUserMutation,
        {
            request: CreateBookingUserRequest
        }
    >(CREATE_USER)

    const onRegisterClick = async (email: string, password: string, first_name: string, last_name: string) => {
        setLoading(true)
        setShowNotification(null)
        if (email.includes('@park-depot.de')) {
            setShowNotification(NotificationType.PD_EMAIL_ERROR)
            setLoading(false)
            return
        }
        try {
            const created = await createUser({
                variables: {
                    request: {
                        first_name,
                        last_name,
                        email,
                        password
                    }
                }
            })

            if (created.data?.booking_create_user?.success) {
                // save vehicle

                await login(email, password, history, true)
            }
        } catch (error: any) {
            const code = error?.graphQLErrors[0]?.extensions?.code
            if (code === 409) {
                setShowNotification(NotificationType.EMAIL_EXISTS_ERROR)
                window.scrollTo({ top: 0, behavior: 'smooth' })
            } else {
                setShowNotification(NotificationType.NEGATIVE)
            }
            setLoading(false)
        }
    }

    return (
        <>
            <SeoHead
                title={seoLang('seo.pages.registerTitle')}
                description={seoLang('seo.pages.registerDescription')}
            />

            <Container>
                <RegisterForm loading={loading} setLoading={setLoading} onRegisterClick={onRegisterClick} />
                <RegisterNotifications notification={showNotification} />
            </Container>
        </>
    )
}

export default Register
